import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { ImportWizardPage } from '~pages/import-wizard';
import { UserRoles } from '~entities/users';
import { checkMinRoleValue } from '~shared/utils/role-guard';

const PendingComponent = () => (
  <div className='flex h-screen items-center justify-center'>Loading…</div>
);

const importDataSearchSchema = z.object({
  step: z.coerce.number().int().min(0).max(5).optional(),
  platform: z
    .enum(['jackrabbit', 'studio_pro', 'studio_director', 'dsp', 'csv'])
    .optional(),
});

export const Route = createFileRoute('/_auth/_layout/_settings/import-data')({
  validateSearch: zodValidator(importDataSearchSchema),
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.ADMIN);
    if (!hasAccess) {
      return redirect({ to: '/dashboard' });
    }
  },
  pendingComponent: PendingComponent,
  component: ImportWizardPage,
});
